import script from "./VJsonPretty.vue?vue&type=script&setup=true&lang=ts"
export * from "./VJsonPretty.vue?vue&type=script&setup=true&lang=ts"

import "./VJsonPretty.vue?vue&type=style&index=0&id=2c871268&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c871268"]])

export default __exports__